<div class="main">
<div *ngIf="isLoggedinUser">
    <div class="row quotation-container">
        <div class="col-md-5 col-lg-5 col-sm-5">
            <label>{{ "quoteReview.quoteReference" | cxTranslate }}</label>
        </div>
        <div class="col-md-5 col-lg-5 col-sm-5">
            <label>{{ "quoteReview.orderType" | cxTranslate }}</label>
        </div>
        <div class="col-md-2 col-lg-2 col-sm-2 ml-15">
            <label>{{ "quoteReview.endUserIndustry" | cxTranslate }}</label>
        </div>
    </div>
    <div class="row quotation-container heading-text">
        <div class="col-md-5 col-lg-5 col-sm-5">
            <label>{{customerProjectName}}</label>
        </div>
        <div class="col-md-5 col-lg-5 col-sm-5">
            <label>{{rfqTypeName}}</label>
        </div>
        <div class="col-md-2 col-lg-2 col-sm-2 ml-15">
            <label>{{endUserIndustry}}</label>
        </div>
    </div>
</div>
<div *ngIf="!isLoggedinUser">
    <div class="row quotation-container">
        <div class="col-md-5 col-lg-5 col-sm-5">
            <label>{{ "quoteReview.quoteReference" | cxTranslate }}</label>
        </div>
        <div class="col-md-5 col-lg-5 col-sm-5">
            <label>{{ "quoteReview.orderType" | cxTranslate }} </label>
        </div>
        <div class="col-md-2 col-lg-2 col-sm-2 ml-15">
            <label>{{ "quoteReview.orderRegion" | cxTranslate }}</label>
        </div>
    </div>
    <div class="row quotation-container heading-text">
        <div class="col-md-5 col-lg-5 col-sm-5">
            <label>{{customerProjectName}}</label>
        </div>
        <div class="col-md-5 col-lg-5 col-sm-5">
            <label>{{rfqTypeName}}</label>
        </div>
        <div class="col-md-2 col-lg-2 col-sm-2 ml-15">
            <label>{{fetchLegalEntityName(legalEntity)}}</label>
        </div>
    </div>
    <div class="row quotation-container endUser-text-m">
        <div class="col-md-5 col-lg-5 col-sm-5">
            <label>End Use Industry</label>
        </div>
    </div>
    <div class="row quotation-container heading-text">
        <div class="col-md-5 col-lg-5 col-sm-5">
            <label>{{endUserIndustry}}</label>
        </div>
    </div>
</div>
</div>